import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { MatTab, MatTabGroup } from '@angular/material/tabs';

import { ChatStateService } from '@lib/chat/services/chat-state.service';

import { MemberProfile } from '@lib/core/models/member.interface';

import { ChatGuaranteesListComponent } from '../chat-guarantees-list/chat-guarantees-list.component';
import { ChatUserProfileComponent } from '../chat-user-profile/chat-user-profile.component';

@Component({
  selector: 'chat-info-board',
  standalone: true,
  imports: [MatTabGroup, MatTab, ChatUserProfileComponent, ChatGuaranteesListComponent, ChatUserProfileComponent, ChatGuaranteesListComponent],
  templateUrl: './chat-info-board.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatInfoBoardComponent {
  protected readonly chatState = inject(ChatStateService);

  member = input.required<MemberProfile>();
}
